import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const ButtonBase = React.forwardRef((props, ref) => {
  const {
    children,
    onClick,
    className,
    unstyled,
    ...rest
  } = props;

  const styledButtonClasses = classNames(
    'sui-h-9 sm:sui-h-11 sui-relative sui-outline-0',
    'focus-visible:sui-bg-button-focus focus-visible:sui-text-primary',
    className
  );

  const classes = unstyled ? className : styledButtonClasses;

  const handleOnClick = (event) => {
    if (onClick) {
      onClick(event);
    }
  };

  return (
    <button
      ref={ref}
      type="button"
      onClick={handleOnClick}
      className={classes}
      {...rest}
    >
      { children }
    </button>
  );
});

ButtonBase.displayName = 'ButtonBase';

ButtonBase.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func,
  unstyled: PropTypes.bool,
  className: PropTypes.string
};

ButtonBase.defaultProps = {
  children: null,
  onClick: null,
  unstyled: false,
  className: null
};

export { ButtonBase };